import {Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NewSubAccountRequest} from '../../../models/new-sub-account-request';
import {SubAccountsPaymentFormComponent} from '../sub-accounts-payment-form/sub-accounts-payment-form.component';
import {NewSubAccountCountResponse} from '../../../models/new-sub-account-count-response';
import {ApiAgentService} from '../../../services/api-agent.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {Router, RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-new-sub-account-details',
  templateUrl: './new-sub-account-details.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, SubAccountsPaymentFormComponent, RouterModule],
  styleUrls: ['./new-sub-account-details.component.scss']
})
export class NewSubAccountDetailsComponent implements OnInit {

  @ViewChild('infoModal') infoModal: ElementRef;
  @ViewChild('modalElm') modalElm: ElementRef;
  @ViewChild('confirmModal') confirmModal: ElementRef;
  @ViewChild('subAccountsPaymentForm') subAccountsPaymentForm: SubAccountsPaymentFormComponent;

  newSubAccountRequest: NewSubAccountRequest;

  loading: boolean;
  modalTitle: string;
  modalMsg: string;
  yesFunction: () => void;
  noFunction: () => void;
  okFunction: () => void;

  constructor(private api: ApiAgentService, private translate: TranslateService, private routing: Router) {
  }

  checkStatus() {
    if (!this.newSubAccountRequest.approved && !this.newSubAccountRequest.rejectReason && !this.newSubAccountRequest.usedInvoice) {
      return 'Pending Approval';
    } else if (!this.newSubAccountRequest.approved && !this.newSubAccountRequest.rejectReason && !this.newSubAccountRequest.paymentDate && this.newSubAccountRequest.usedInvoice) {
      return 'Cancelled';
    } else if (this.newSubAccountRequest.approved && !this.newSubAccountRequest.paymentDate) {
      return 'Pending Payment';
    } else if (!this.newSubAccountRequest.approved && this.newSubAccountRequest.rejectReason) {
      return 'Rejected';
    } else if (this.newSubAccountRequest.approved && this.newSubAccountRequest.paymentDate && !this.newSubAccountRequest.usedInvoice) {
      return 'Ready To Use';
    } else if (this.newSubAccountRequest.approved && this.newSubAccountRequest.paymentDate && this.newSubAccountRequest.usedInvoice) {
      return 'Used';
    }
  }

  ngOnInit(): void {
  }

  cancelRequest() {
    this.modalTitle = 'Cancel the request';
    this.modalMsg = 'Are you sure want to cancel this request';
    this.yesFunction = () => {
      this.api.cancelSubAccountRequest(this.newSubAccountRequest.id, this.newSubAccountRequest.merchantId).then(async cancelledRequest => {
        this.modalTitle = await this.translate.get('Cancelled Request').toPromise();
        this.modalMsg = await this.translate.get('Request successfully cancelled.').toPromise();
        this.okFunction = () => {
          window.top.location.reload();
        };
        $(this.infoModal.nativeElement).modal('show');
      }).catch(async error => {
        this.modalTitle = await this.translate.get('Cancel Request Error').toPromise();
        this.modalMsg = await this.translate.get('Could not cancel the request. Please try again').toPromise();
        $(this.infoModal.nativeElement).modal('show');
      });
    };
    this.noFunction = () => {
    };
    $(this.confirmModal.nativeElement).modal('show');
  }

  openModal(newSubAccountRequest: NewSubAccountRequest) {
    this.newSubAccountRequest = newSubAccountRequest;
    $(this.modalElm.nativeElement).modal('show');
  }

  closeModal() {
    $(this.modalElm.nativeElement).modal('hide');
  }

  payRequest() {
    let newSubAccountCountRequest: NewSubAccountCountResponse = {
      approvalRequestNo: this.newSubAccountRequest.id,
      subAccountCount: this.newSubAccountRequest.count,
      approved: this.newSubAccountRequest.approved,
      response: '',
      absherConfirmed: null,
      totalAmount: this.newSubAccountRequest.totalAmount
    };

    this.subAccountsPaymentForm.loadData(newSubAccountCountRequest)
      .then(value => {
        if (value) {
          this.subAccountsPaymentForm.openModal();
        }
      }).catch(error => {
      alert(error);
    });
  }

  useRequest() {
    this.closeModal();
    this.routing.navigateByUrl('/private/assign-sub-accounts/' + this.newSubAccountRequest.id).then();
  }
}
